import { useRef } from "react";
import {
  motion,
  useMotionValue,
  useSpring,
  useTransform,
  useMotionTemplate,
  useScroll,
} from "framer-motion";

export default function KnotFigure() {
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);

  const rotateX = useSpring(useTransform(my, [0, 1], [7, -7]), { stiffness: 120, damping: 18 });
  const rotateY = useSpring(useTransform(mx, [0, 1], [-7, 7]), { stiffness: 120, damping: 18 });
  const spotX = useTransform(mx, (v) => v * 100);
  const spotY = useTransform(my, (v) => v * 100);
  const spotlight = useMotionTemplate`radial-gradient(420px circle at ${spotX}% ${spotY}%, rgba(37,165,183,0.28), transparent 65%)`;

  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const parallaxY = useTransform(scrollYProgress, [0, 1], [40, -60]);

  function handleMove(e) {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    mx.set((e.clientX - rect.left) / rect.width);
    my.set((e.clientY - rect.top) / rect.height);
  }

  function handleLeave() {
    mx.set(0.5);
    my.set(0.5);
  }

  return (
    <motion.div
      ref={ref}
      data-testid="hero-knot-figure"
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      initial={{ opacity: 0, scale: 0.94, y: 30 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 1.1, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
      style={{ perspective: 900 }}
      className="relative mx-auto w-full max-w-md lg:max-w-none"
    >
      <motion.div style={{ y: parallaxY }} className="relative">
        <motion.div
          style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
          className="relative overflow-hidden rounded-[28px] ring-1 ring-white/15 shadow-[0_40px_120px_-20px_rgba(0,0,0,0.7)]"
        >
          <img
            src="/assets/knot-logo.png"
            alt="The Knot Forgotten figure-eight rope knot"
            className="block aspect-square w-full object-cover"
            draggable="false"
          />
          <motion.div style={{ background: spotlight }} className="pointer-events-none absolute inset-0" />
          <div className="pointer-events-none absolute inset-0 rounded-[28px] ring-1 ring-inset ring-white/10" />
        </motion.div>

      </motion.div>
    </motion.div>
  );
}
